import React from 'react';
import { formatDateTime } from '@factorin/util';

import { FocusableDiv, Text, GradientPlaceholder, cn } from 'Modules/ui';
import { paginationStatuses } from 'Modules/business/data';

import { DownloadButton } from './DownloadButton';
import styles from './index.module.scss';


export const DocumentItem = ({
    index,
    data: document,
    queueStatus,
    isSelected,
    onClick,
    style,
}) => {
    const isPlaceholder = queueStatus !== paginationStatuses.COMPLETE;
    return (
        <FocusableDiv
            className={cn(
                styles.documentItem,
                isPlaceholder && styles.placeholder,
                isSelected && styles.selected,
            )}
            focusedClassName={!isSelected && styles.focused}
            onClick={isPlaceholder ? undefined : onClick}
            style={style}
        >
            <Text
                component='div'
                textType='bold'
                className={styles.filename}
                title={isPlaceholder ? undefined : document.Number}
            >
                {isPlaceholder
                    ? <GradientPlaceholder seed={index} length={[12, 20]} />
                    : document.Number
                }
            </Text>
            <Text component='span' className={styles.date}>
                {isPlaceholder
                    ? <GradientPlaceholder length={16} />
                    : formatDateTime(document.Date)
                }
            </Text>
            {document && (
                <div className={styles.menu}>
                    <DownloadButton documentId={document.Uid} />
                </div>
            )}
        </FocusableDiv>
    );
};
